module.exports = __webpack_public_path__ + "static/media/black_wave.8a7f79f6.svg";